module.exports = __webpack_public_path__ + "147e62363547bf81eec0d5345cdb214f.fbx";